export const DataATHMovilCurrencies = [
    { value: "EUR", label: "Euro - EUR" },
    { value: "USD", label: "United States dollar - USD" },
];
export const DataATHMovilLanguages = [
    { value: "en", label: "English" },
    { value: "es", label: "Español" },
];
export const DataATHMovilThemes = [
    { value: "btn", label: "Default" },
    { value: "btn-light", label: "Light" },
    { value: "btn-dark", label: "Dark" },
];
export const DataATHMovilEnvironments = [
    { value: "sandbox", label: "Test" },
    { value: "production", label: "Live" },
];
//# sourceMappingURL=ath_movil_options.js.map